var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('carousel',{staticClass:"carouser-wrapper",attrs:{"per-page":_vm.perPageNumber,"per-page-custom":[
    [0, 1],
    [768, 2],
    [1024, _vm.perPageNumber]
  ],"loop":true,"navigation-next-label":"<span class='icon bis-right'></span>","navigation-prev-label":"<span class='icon bis-left'></span>","navigation-enabled":false,"pagination-active-color":"#00CB94","pagination-color":"#d4d4d4"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }